// utils/ShareResourceUtils.ts
import { TeamsInterface } from 'ts-interfaces';
import { getUrlFromRef } from '../../../libs/firebase';

// Define color palette for avatars
export const AVATAR_COLORS = [
  '#F87171', // red
  '#60A5FA', // blue
  '#34D399', // green
  '#A78BFA', // purple
  '#FBBF24', // yellow
  '#EC4899', // pink
  '#6EE7B7', // teal
  '#FCA5A5', // light red
  '#93C5FD', // light blue
  '#C4B5FD'  // light purple
];

// Function to get a consistent color for a user based on their UID
export const getAvatarColor = (userUid: string | null) => {
  if (!userUid) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < userUid.length; i++) {
    hash = userUid.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

// Function to get avatar text (first letter of name or email)
export const getAvatarText = (item: TeamsInterface) => {
  if (item.first_name) {
    return item.first_name.charAt(0).toUpperCase();
  } else if (item.email) {
    return item.email.charAt(0).toUpperCase();
  }
  return '?';
};

// Function to get display name
export const getDisplayName = (item: TeamsInterface) => {
  if (item.first_name && item.last_name) {
    return `${item.first_name} ${item.last_name}`;
  } else if (item.first_name) {
    return item.first_name;
  } else if (item.email) {
    return item.email;
  }
  return 'Unknown User';
};

// Email validation
export const isValidEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Get image URL from reference
export { getUrlFromRef };